<template>
  <b-modal @ok="onSubmit" id="classwork_file" ref="classwork_file" title="Add classwork file">
    <validation-observer
        v-slot="{ handleSubmit }"
        ref="refFormObserver"
    >
      <b-form
          ref="form"
          @submit.stop.prevent="handleSubmit(onSubmit($event))"
          class="form validate"
      >

        <div class="select-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="name"
              :rules="{required: true}"
          >
            <b-form-group
                :label="$t('Название')"
                label-for="name"
            >
              <b-form-input
                  type="text"
                  trim
                  v-model="form.name"
              />
            </b-form-group>
          </validation-provider>
        </div>
        <div class="select-wrapper">
          <validation-provider
              v-slot="validationContext"
              name="file"
              :rules="{required: true}"
          >
            <b-form-group
                :label="$t('Загрузите файл')"
                label-for="number"
            >
              <b-form-file
                  accept=".doc, .docx, .pptx, .pdf, .ppt"
                  type="file"
                  trim
                  v-model="form.file"
              />
            </b-form-group>
          </validation-provider>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import StudyingLessonsApi from "@/api/studying-lessons";


export default {
  name: "addClassWorkModal",
  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      form: {
        name: '',
        file: '',
      },
      classWorks: [],
    }
  },
  methods: {
    hideModal() {
      this.form = {
        name: '',
        file: '',
      }
      this.$refs['classwork_file'].hide();
    },
    onSubmit($event) {
      $event.preventDefault();
      let fd = new FormData();

      fd.append('file_name', this.form.name)
      fd.append('file', this.form.file)

      StudyingLessonsApi.createClassWork(fd)
        .then(res => {
          this.hideModal();
          this.$emit('fileUpdated', res.data)
        })
        .catch(err => {console.log(err)})

    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>
